module.exports = __webpack_public_path__ + "static/media/photo2.9e0114f8.png";